// Minimal inline SVG flags — Portugal & UK
export const FlagPT = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="9" height="16" fill="#046A38" />
    <rect x="9" width="15" height="16" fill="#DA291C" />
    <circle cx="9" cy="8" r="2.7" fill="#FFD700" stroke="#fff" strokeWidth="0.4" />
  </svg>
);

export const FlagUK = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
    <clipPath id="t">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
    </clipPath>
    <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
    <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
    <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
    <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
    <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
  </svg>
);
